import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";
import { Plus } from "lucide-react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import ComboMealListTabs from "@/components/menu-management/combo-meal/combo-meal-list/combo-meal-list-tabs";
import DraftListTabs from "@/components/menu-management/combo-meal/combo-meal-list/draft-list-tabs";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllComboMeals,
  clearComboMealMessages,
} from "@/redux/slice/menu-manage-slice/combo-meal-slice";
import { clearItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";
import useAuth from "@/hooks/useAuth";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import hasPermission from "@/hooks/hasPermission";

function ComboMeal() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { getLoading, requestStatus, error } = useSelector(
    (state) => state.menuManage.comboMeal
  );

  useEffect(() => {
    dispatch(fetchAllComboMeals(user.restaurant_id));
    dispatch(clearComboMealMessages());
    dispatch(clearItemVariants());
  }, [user.restaurant_id]);

  if (getLoading) return <TableSkeleton links={backofficeLinks} />
  return (
    <Layout2
      pageName={{ title: "Combo/ Set Meal / Offer" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Menu Management", path: "/backoffice/menu/drinks" },
        {
          name: "Combo/ Set Meal / Offer",
          path: "/backoffice/menu/combo-meal",
        },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <div className="flex justify-end items-start md:items-center md:flex-row flex-col  w-full">
          {hasPermission("back_office.menu_management.create_combo_meal") && (
            <Link to={"/backoffice/menu/combo-meal/create"}>
              <Button>
                <Plus /> Create Combo Meal
              </Button>
            </Link>
          )}
        </div>
        <Tabs
          valueKey="menu-combo-meal"
          className="bg-transparent relative"
          defaultValue="drink"
        >
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="drink">
              Combo Meal List
            </TabsTrigger>
            <TabsTrigger value="draft">Draft List</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <ComboMealListTabs />
          <DraftListTabs />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default ComboMeal;
